/**
 * Global error handlers for unhandled JS errors and promise rejections.
 * Call installGlobalErrorHandlers() once at app startup (before React mounts).
 */

import { errorLogger } from "./errorLogger";
import { consoleCapture } from "./consoleCapture";
import { networkCapture } from "./networkCapture";

export function installGlobalErrorHandlers(): void {
  // Install passive capture ring buffers for bug report diagnostics
  consoleCapture.install();
  networkCapture.install();

  window.onerror = (message, source, lineno, colno, error) => {
    errorLogger.log({
      error_type: "unhandled",
      severity: "critical",
      message: typeof message === "string" ? message : "Unknown error",
      stack_trace: error?.stack || `${source}:${lineno}:${colno}`,
      component_name: typeof source === "string" ? source : undefined,
    });
    return false;
  };

  window.addEventListener("unhandledrejection", (event) => {
    const error = event.reason;
    errorLogger.log({
      error_type: "unhandled",
      severity: "critical",
      message: error instanceof Error ? error.message : String(error || "Unhandled promise rejection"),
      stack_trace: error instanceof Error ? error.stack : undefined,
    });
  });
}
